
export class FilterSettings {

  public searchText: string = "";
  public product: string = "";
  public project: string = "";
  public endUser: string = "";
  public customer: string = "";
  public poNumber: string = "";
  public salesManager: string = "";
  public technicalEngineer: string = "";
  public projectManager: string = "";
  public projectManager2: string = "";
  public planner: string = "";
  public mechanicalEngineer: string = "";
  public mechanicalDrafter: string = ""
  public electricalEngineer: string = "";
  public electricalDrafter: string = "";
  public activity: string = "";
  public status: string = "";
  public poStartDate: Date | null = null;
  public poEndDate: Date | null = null;
  public shipStartDate: Date | null = null;
  public shipEndDate: Date | null = null;

  public dayRangeMin: number = -180;
  public dayRangeMax: number = 360;
  public selectedDay: number = 0;
  public startDate: Date;
  public dates: Date[] = [];
  public months: string[] = [];

  public showOnlyMilestones: boolean = false;
  public showConfirmed: boolean = true;
  public showUnconfirmed: boolean = true;
  public showCustomer: boolean = true;
  public showSales: boolean = true;
  public showEngineering: boolean = true;
  public showProduction: boolean = true;
  public showEarly: boolean = true;
  public showOnTime: boolean = true;
  public showInDanger: boolean = true;
  public showOnHold: boolean = true;
  public showLate: boolean = true;
  public showWeekends: boolean = true;
  public showFridays: boolean = true;
  public showWeeks: boolean = false;
  public daysShown: number = 40;
  public startAtToday: boolean = true;
  public dayWidth: number = 25; 

  public dayRangeChanged: (() => void) | null = null;
  public startAtChanged: (() => void) | null = null;

  public showResetAll(): boolean {
    let count = 0;
    if (this.searchText) count++;
    if (this.product) count++;
    if (this.project) count++;
    if (this.endUser) count++;
    if (this.customer) count++;
    if (this.poNumber) count++;
    if (this.salesManager) count++;
    if (this.technicalEngineer) count++;
    if (this.projectManager) count++;
    if (this.projectManager2) count++;
    if (this.planner) count++;
    if (this.mechanicalEngineer) count++;
    if (this.mechanicalDrafter) count++;
    if (this.electricalEngineer) count++;
    if (this.electricalDrafter) count++;
    if (this.activity) count++;
    if (this.status) count++;
    if (this.poStartDate) count++;
    if (this.poEndDate) count++;
    if (this.shipStartDate) count++;
    if (this.shipEndDate) count++;
    return count > 0;
  }
}
